import { render, staticRenderFns } from "./KpiIndex.vue?vue&type=template&id=00905dca&"
import script from "./KpiIndex.vue?vue&type=script&lang=js&"
export * from "./KpiIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports